import {
  type AnalysisVersionInfo,
  DuplicateAnalysisBadRequestErrorCode,
  DuplicateAnalysisNotFoundErrorCode,
} from "Infrastructure/ApiZfp/Schema";
import { type ResourcePathType, Resources } from "Infrastructure/Translations/Resources";

export type SourceVersion = Pick<AnalysisVersionInfo, "guid" | "version">;

export const getDuplicateErrorResource = (code: unknown): ResourcePathType | null => {
  switch (code) {
    case DuplicateAnalysisBadRequestErrorCode.analysis_in_progress:
      return Resources.AnalysisDetail.Duplicate.Error.InProgress;
    case DuplicateAnalysisBadRequestErrorCode.nsure_self_dealing_forbidden:
      return Resources.AnalysisDetail.Duplicate.Error.SelfDealingForbidden;
    case DuplicateAnalysisNotFoundErrorCode.nsure_agent_not_found:
      return Resources.AnalysisDetail.Duplicate.Error.NsureAccountMissing;
    case DuplicateAnalysisNotFoundErrorCode.mango_agent_not_found:
      return Resources.AnalysisDetail.Duplicate.Error.MangoAccountMissing;
    default:
      return null;
  }
};
